import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const creditTypes: Record<string, string> = {
  '1': '3 hrs. Agency Law',
  '2': '3 hrs. Legal Issues',
  '3': '3 hrs. Fair Housing',
  '4': '3 hrs. Contract Law',
  '5': '3 hrs. Comm. Standards',
  '6': '3 hrs. Disclosure',
  '7': '3 hrs. General',
  '8': 'NONE',
  '9': 'Req. For Licensees'
};
export function ViewCreditType() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const name = id && creditTypes[id] ? creditTypes[id] : 'Agency Law';
  return <div className="space-y-4" data-id="element-2528">
      <div className="flex items-center justify-between" data-id="element-2529">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2530">Credit Type</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types')} data-id="element-2531">
          ← Back to Credit Types
        </Button>
      </div>

      <Card data-id="element-2532">
        <CardContent className="pt-6" data-id="element-2533">
          <table className="text-sm w-full max-w-sm" data-id="element-2534">
            <tbody data-id="element-2535">
              <tr data-id="element-2536">
                <td className="py-2 pr-6 font-medium text-slate-700 w-24" data-id="element-2537">
                  Name
                </td>
                <td className="py-2 text-slate-900" data-id="element-2538">{name}</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-6" data-id="element-2539">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/credit-types/edit/${id}`)} data-id="element-2540">
              Edit
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}